import React, { useEffect, useState } from "react";
import moment from "moment";

const AgmtSystemInfo = ({ agmtDetails }) => {
  const [agmts, setAgmts] = useState<any>([]);
  useEffect(() => {
    setAgmts({
      createdBy: ["Created By", agmtDetails.createdBy],
      updatedBy: ["Modified By", agmtDetails.updatedBy],
      createdOn: [
        "Created Date",
        agmtDetails.createdOn
          ? moment(agmtDetails.createdOn).format("M/D/YYYY hh:mm A")
          : agmtDetails.createdOn,
      ],
      updatedOn: [
        "Modified Date",
        agmtDetails.updatedOn
          ? moment(agmtDetails.updatedOn).format("M/D/YYYY hh:mm A")
          : agmtDetails.updatedOn,
      ],
    });
  }, [agmtDetails]);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-xs p-2 px-7">
      {Object.values(agmts).map((item: any, i) => {
        return (
          <div key={i} className="w-full border-b border-gray-200 py-1">
            <div className="grid grid-cols-2">
              <label className="expandedLabel fontExpand text-left ml-2">
                <span className="">{item[0]}: </span>
              </label>
              <span className="expandedData fontExpand ">{item[1]}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AgmtSystemInfo;
